export default function Table({ title, rows }) {
  if (!rows || rows.length === 0) {
    return <div className="card">No data available</div>;
  }

  // ❌ Columns to hide (security / UI cleanup)
  const HIDDEN_COLUMNS = ["device_ip"];

  // Sort rows by `id` ascending (safe copy)
  const sortedRows = [...rows].sort((a, b) => {
    if (a.id == null || b.id == null) return 0;
    return a.id - b.id;
  });

  // Filter columns dynamically
  const columns = Object.keys(sortedRows[0]).filter(
    col => !HIDDEN_COLUMNS.includes(col)
  );

  return (
    <div className="card table-card">
      {/* ===== Header ===== */}
      <div className="table-header">
        <h3>{title}</h3>
        <span className="table-count">{sortedRows.length}</span>
      </div>

      {/* ===== Table Wrapper ===== */}
      <div className="table-wrapper">
        <table className="styled-table">
          <thead>
            <tr>
              {columns.map(col => (
                <th key={col}>
                  {col.replace(/_/g, " ").toUpperCase()}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {sortedRows.map((row, i) => (
              <tr key={i}>
                {columns.map(col => (
                  <td key={col}>
                    {row[col] ?? "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
